<template>
  <component :is="tag" :type="btnType" class="btn btn-custom"
    :style="[
      {width: w},
      {height: h},
      {padding: p},
      {border: clBorder ? `1px ${clBorder} #dee2e6` : (bg == 'white' ? '1px solid #F2EFF1' : '')}
    ]"
    :class="[
      {[`d-${d}`]: d},
      {[`align-items-${alignItems}`]: alignItems},
      {[`justify-content-${justify}`]: justify},
      {'btn-icon': icon},
      {[`fw-${fw}`]: fw},
      {[`bg-${bg}`]: bg},
      {[`rounded-${rounded}`]: rounded},
      {'no-focus': noFocus},
      bg == 'black' ? 'text-white' : ''
    ]">
    
      <i v-if="icon" :class="[{[`fas fa-${icon}`] : icon}, {[`fs-${fsIcon}`]: fsIcon}]"></i>
      <slot />
  </component>
</template>

<script>
export default {
  data(){
    return{
      isLoading: true
    }
  },
  props: {
    tag: {
      type: String,
      default: 'button'
    },
    btnType:{
      type: String,
      default: 'button'
    },
    btnText:{
      type: String,
      default: ''
    },
    customClass:{
      type:Array,
      default:() => []
    },
    fw:{
      type: String,
      default: 'normal'
    },
    bg:{
      type: String,
      default: 'black'
    },
    icon: {
      type: String,
      default: ''
    },
    loading: Boolean,
    rounded: {
      type: String,
      default: ''
    },
    w: {
      type: String,
      default: ''
    },
    h: {
      type: String,
      default: ''
    },
    p: {
      type: String,
      default: ''
    },
    fsIcon: String,
    noFocus: {
      type: Boolean,
      default: false
    },
    d: {
      type: String,
      default: ''
    },
    alignItems: {
      type: String,
      default: 'center'
    },
    justify: {
      type: String,
      default: 'center'
    },
    clBorder: {
      type: String,
      default: ''
    }
  },
  methods:{
    onClick(evt){
      this.$emit("click", evt);
    }
  }
}
</script>

<style>

</style>